import React, { createContext, useContext, useState, useCallback } from 'react';

interface ModalState {
  isOpen: boolean;
  type: string | null;
  data: any;
}

interface ModalContextType {
  modal: ModalState;
  openModal: (type: string, data?: any) => void;
  closeModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: React.ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [modal, setModal] = useState<ModalState>({
    isOpen: false,
    type: null,
    data: null,
  });

  const openModal = useCallback((type: string, data?: any): void => {
    setModal({
      isOpen: true,
      type,
      data,
    });
  }, []);

  const closeModal = useCallback((): void => {
    setModal({
      isOpen: false,
      type: null,
      data: null,
    });
  }, []);

  const value: ModalContextType = {
    modal,
    openModal,
    closeModal,
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
}; 